module.exports = __webpack_public_path__ + "img/Check.1a5196e9.svg";